import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader, CheckCircle, XCircle } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking'); // 'checking', 'success', 'error'
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifySubscription = async () => {
      try {
        // Wait a short moment to allow webhook processing
        await new Promise(resolve => setTimeout(resolve, 2000));

        const token = localStorage.getItem('access_token');
        if (!token) {
          throw new Error('No authentication token found');
        }

        const response = await axios.get(`${API_URL}/subscriptions/verify`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.data?.is_active) {
          setStatus('success');
          // Wait a moment to show success message before redirecting
          setTimeout(() => {
            navigate('/');
          }, 1500);
        } else {
          throw new Error('Subscription not active');
        }
      } catch (error) {
        console.error('Error verifying subscription:', error);
        setStatus('error');
        setError(error.message || 'Failed to verify subscription');
      }
    };

    verifySubscription();
  }, [navigate]);

  const renderContent = () => {
    switch (status) {
      case 'checking':
        return (
          <>
            <Loader className="w-12 h-12 animate-spin text-blue-500 mb-4" />
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">
              Processing Your Subscription
            </h2>
            <p className="text-gray-600 dark:text-gray-300">
              Please wait while we verify your subscription...
            </p>
          </>
        );

      case 'success':
        return (
          <>
            <CheckCircle className="w-12 h-12 text-green-500 mb-4" />
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">
              Subscription Activated!
            </h2>
            <p className="text-gray-600 dark:text-gray-300">
              Redirecting you to the application...
            </p>
          </>
        );

      case 'error':
        return (
          <>
            <XCircle className="w-12 h-12 text-red-500 mb-4" />
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">
              Subscription Error
            </h2>
            <p className="text-red-600 dark:text-red-400 mb-4">
              {error || 'An error occurred while processing your subscription'}
            </p>
            <button
              onClick={() => navigate('/subscription')}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
            >
              Return to Subscription Page
            </button>
          </>
        );
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
      <div className="text-center p-8 bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full">
        {renderContent()}
      </div>
    </div>
  );
};

export default SubscriptionSuccess;